var TOKEN_MARK = 'prism-token';
export default TOKEN_MARK;
//# sourceMappingURL=TOKEN_MARK.js.map